__turbopack_context__.v({
  "bannerContent": "PlanCard-module-scss-module___c1BSW__bannerContent",
  "cartContext": "PlanCard-module-scss-module___c1BSW__cartContext",
  "colorBar": "PlanCard-module-scss-module___c1BSW__colorBar",
  "compareCheckbox": "PlanCard-module-scss-module___c1BSW__compareCheckbox",
  "compareDisabled": "PlanCard-module-scss-module___c1BSW__compareDisabled",
  "compareLabel": "PlanCard-module-scss-module___c1BSW__compareLabel",
  "compareWrapper": "PlanCard-module-scss-module___c1BSW__compareWrapper",
  "disabledTooltip": "PlanCard-module-scss-module___c1BSW__disabledTooltip",
  "disabledTooltipBottom": "PlanCard-module-scss-module___c1BSW__disabledTooltipBottom",
  "disabledTooltipLeft": "PlanCard-module-scss-module___c1BSW__disabledTooltipLeft",
  "fade": "PlanCard-module-scss-module___c1BSW__fade",
  "fade-slide": "PlanCard-module-scss-module___c1BSW__fade-slide",
  "footer": "PlanCard-module-scss-module___c1BSW__footer",
  "gapCard": "PlanCard-module-scss-module___c1BSW__gapCard",
  "labelRow": "PlanCard-module-scss-module___c1BSW__labelRow",
  "maCard": "PlanCard-module-scss-module___c1BSW__maCard",
  "open-from-center": "PlanCard-module-scss-module___c1BSW__open-from-center",
  "pdpCard": "PlanCard-module-scss-module___c1BSW__pdpCard",
  "planActions": "PlanCard-module-scss-module___c1BSW__planActions",
  "planBasicDetails": "PlanCard-module-scss-module___c1BSW__planBasicDetails",
  "planCard": "PlanCard-module-scss-module___c1BSW__planCard",
  "planCardContent": "PlanCard-module-scss-module___c1BSW__planCardContent",
  "planCardSelected": "PlanCard-module-scss-module___c1BSW__planCardSelected",
  "planCardWrapper": "PlanCard-module-scss-module___c1BSW__planCardWrapper",
  "planCarrier": "PlanCard-module-scss-module___c1BSW__planCarrier",
  "planDeleteAction": "PlanCard-module-scss-module___c1BSW__planDeleteAction",
  "planDetails": "PlanCard-module-scss-module___c1BSW__planDetails",
  "planHeader": "PlanCard-module-scss-module___c1BSW__planHeader",
  "planId": "PlanCard-module-scss-module___c1BSW__planId",
  "planInfo": "PlanCard-module-scss-module___c1BSW__planInfo",
  "planMainActions": "PlanCard-module-scss-module___c1BSW__planMainActions",
  "planName": "PlanCard-module-scss-module___c1BSW__planName",
  "planRecommendedBadge": "PlanCard-module-scss-module___c1BSW__planRecommendedBadge",
  "planTypeBadge": "PlanCard-module-scss-module___c1BSW__planTypeBadge",
  "planTypeBanner": "PlanCard-module-scss-module___c1BSW__planTypeBanner",
  "reviewAndCart": "PlanCard-module-scss-module___c1BSW__reviewAndCart",
  "saveButtonWrapper": "PlanCard-module-scss-module___c1BSW__saveButtonWrapper",
  "spin": "PlanCard-module-scss-module___c1BSW__spin",
});
